export function SubscriberGrowthChartShimmer() {
  const bars = Array.from({ length: 12 });

  return (
    <>
      <div className="w-full h-[350px] flex flex-col justify-center items-center gap-2">
        {bars.map((_, idx) => (
          <div
            key={idx}
            className="w-full h-2 bg-gray-200 rounded animate-pulse"
            style={{ width: `${60 + Math.random() * 40}%` }}
          />
        ))}

        <div className="mt-6">
          <svg
            className="animate-spin h-8 w-8 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
        </div>
      </div>
    </>
  );
}
